export { Card } from './Card'
export type { CardProps } from './Card.types'
